// extracted by css-extract-rspack-plugin
export default {"title":"kSiDlcZACJwVO09Q"};